import React, { useEffect, useState } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";
import "./App.scss";
import AppRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import RouteDiagnostics from "./components/RouteDiagnostics";
import BuildBadge from "./components/BuildBadge";
import { hasValidSession } from "./utils/session";
import { useAuthStore, useSettingStore } from "./redux/auth-store";
import "react-toastify/dist/ReactToastify.css";
import { getMasterEnvironment } from "./services/common.service";

function App() {
  const { user: authUser, token, setUser, setToken } = useAuthStore();
  const { setSettings } = useSettingStore();
  const [mounted, setMounted] = useState<boolean>(false);
  // const { user, isAuthenticated, isLoading, error } = useAuth0();
  const themeMode = "light";

  useEffect(() => {
    document.documentElement.dataset.bsTheme = themeMode;
  }, [themeMode]);

  useEffect(() => {
    if (hasValidSession()) {
      setToken("true");
    }
  }, [setToken]);

  useEffect(() => {
    if (authUser) {
      setUser(authUser);
    }
  }, [authUser, setUser]);

  useEffect(() => {
    setMounted(true);
  }, []);

  /**
   * Once the app is mounted then
   * get configs for the app.
   */
  useEffect(() => {
    if (!mounted) return;
    const id = window.setTimeout(() => getConfigs(), 0);
    return () => window.clearTimeout(id);
  }, [mounted]);

  /**
   * Retrieves configurations and sets them using dispatch.
   * @returns {void}
   */
  const getConfigs = () => {
    getMasterEnvironment().then(
      (res: any) => {
        const { data } = res;
        if (data && Object.keys(res.data).length) {
          setSettings(res.data);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };

  // if (!token) {
  //   return <Loader isLoading={true} />;
  // }

  return (
    <>
      <RouteDiagnostics />
      <BuildBadge />
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
